define('modules/editor/views/toolbar',['require','exports','module','i18n','base/layout','lib/util','./navigation_tabs','../models/editorstate','modules/page_listing/models/page_update','services/auth/trial','common/views/alert_view','services/auth/info','ldsh!../templates/toolbar'],function (require, exports, module) {
  'use strict';
  require('i18n');
  var Layout = require('base/layout'),
    util = require('lib/util'),
    NavigationTabs = require('./navigation_tabs'),
    EditorState = require('../models/editorstate'),
    PageUpdateCommand = require('modules/page_listing/models/page_update'),
    AuthTrial = require('services/auth/trial'),
    authTrial = new AuthTrial(),
    AlertView = require('common/views/alert_view'),
    AuthInfo = require('services/auth/info'),
    authInfo = new AuthInfo();

  module.exports = Layout.extend({
    regions: {
      tabs: '.js-nav-tabs',
    },

    events: {
      'click .js-save': 'savePage',
      'click .js-preview': 'previewPage',
      'click .js-margins': 'toggleMargins',
      'click .js-tree': 'toggleTree',
      'click .js-redo': 'redoChanges',
      'click .js-undo': 'undoChanges',
      'click .js-publish': 'publishLP',
      'click .js-update': 'updateLP',
      'click .js-unpublish': 'unpublishLP',
      'click .js-see-production': 'seeProduction',
      'click .js-trigger-toolgroup': 'showToolgroup',
    },

    initialize: function (options) {
      this.data = options.data;
      this.page = options.page;
      this.vent = options.vent;
      this.regions.tabs.show(
        new NavigationTabs({
          collection: this.data.collection,
          vent: this.vent,
        })
      );

      this.listenTo(this.data, 'history:track', this._onHistoryTrack);
      this.listenTo(this.data, 'history:commit', this._onHistoryCommit);
      this.listenTo(this.data, 'history:disable', this._setupHistoryButtons);
      this.listenTo(EditorState, EditorState.VARIANT_CHANGED, this._setupChangesPending);

      // Hide toolbar submenu when clicked outside of it
      $('html').click(
        function () {
          this.$('.ed-sub-toolgroup').addClass('hidden');
        }.bind(this)
      );
    },

    template: require('ldsh!../templates/toolbar'),

    savePage: function (e) {
      //is disabled?
      var $target = $(e.currentTarget);

      if (!$target.hasClass('is-disabled')) {
        $target.find('.ed-icon').addClass('flip');
        this.vent.trigger('variant:save');
        this.page.set('outdated', true);
        this.render();
      }
    },

    previewPage: function () {
      this.vent.trigger('page:preview');
    },

    toggleMargins: function (e) {
      var status = EditorState.get('displayMargins');
      EditorState.set('displayMargins', !status);
      this.$('.js-margins').toggleClass('is-active', !status);
    },

    toggleTree: function () {
      var status = EditorState.get('displayTree');
      EditorState.set('displayTree', !status);
      this.$('.js-tree').toggleClass('is-active', !status);
      $('.ed-wrapper').toggleClass('layer-tree-active', !status);
    },

    redoChanges: function () {
      if (!$(e.currentTarget).hasClass('is-disabled')) {
        this.vent.trigger('variant:redo');
      }
    },

    undoChanges: function (e) {
      if (!$(e.currentTarget).hasClass('is-disabled')) {
        this.vent.trigger('variant:undo');
      }
    },

    publishLP: function (e) {
      var self = this;
      var $currentButton = $(e.currentTarget).find('.ed-icon');
      var errorMessage = $.i18n.t('pageListing.notifications.landingError'),
        publishMessage = $.i18n.t('pageListing.notifications.landingPublished');
      if (authTrial.hasExpired()) return this._displayTrialNotification();

      $currentButton.addClass('flip');

      this.page.save(
        { published: true },
        {
          patch: true,
          success: function () {
            $currentButton.removeClass('flip');
            self.showAlert(publishMessage, true);
            self.page.set('outdated', false);
            self.render();
          },
          error: function () {
            self.page.set('published', false);
            self.showAlert(errorMessage, false);
          },
        }
      );
    },

    updateLP: function (e) {
      var self = this;
      var $currentButton = $(e.currentTarget).find('.ed-icon');
      var errorMessage = $.i18n.t('pageListing.notifications.landingError'),
        message = $.i18n.t('pageListing.notifications.landingUpdated'),
        updateCommand = new PageUpdateCommand({}, { pageId: this.page.id });

      $currentButton.addClass('rotate');

      updateCommand.save(null, {
        success: function () {
          $currentButton.removeClass('rotate');
          self.showAlert(message, true);
          self.page.set('outdated', false);
          self.render();
        },
        error: function () {
          self.showAlert(errorMessage, false);
        },
      });
    },

    unpublishLP: function (e) {
      var self = this;
      var $currentButton = $(e.currentTarget).find('.ed-icon');
      var errorMessage = $.i18n.t('pageListing.notifications.landingError'),
        unpublishMessage = $.i18n.t('pageListing.notifications.landingUnpublished');

      $currentButton.addClass('flip');

      this.page.save(
        { published: false },
        {
          patch: true,
          success: function () {
            $currentButton.removeClass('flip');
            self.showAlert(unpublishMessage, true);
            self.render();
          },
          error: function () {
            self.page.set('published', true);
            self.showAlert(errorMessage, false);
          },
        }
      );
    },

    seeProduction: function () {
      var redirectWindow = window.open(util.addHttpsToUrl(this.page.get('full_url')), '_blank');
      return redirectWindow.location;
    },

    showToolgroup: function (e) {
      this.$('.ed-dropdown.open').removeClass('open');
      this.$('.js-trigger-toolgroup').removeClass('is-menu-active');

      const $currentTartget = $(e.currentTarget);
      $('.ed-toolgroup')
        .find('button')
        .not($currentTartget)
        .removeClass('is-menu-active')
        .next('.ed-dropdown-menu')
        .removeClass('open')
        .addClass('hidden');

      $currentTartget
        .addClass('is-menu-active')
        .next('.ed-dropdown-menu')
        .toggleClass('hidden open');

      e.stopPropagation();
    },

    showAlert: function (message, isSuccess) {
      AlertView.showAlert({
        message: message,
        alertType: isSuccess ? 'success' : 'danger',
      });
    },

    helpers: function () {
      var viewParams = {
        published: this.page.get('published'),
        outdated: this.page.get('outdated'),
        multiTabs: this.data.collection && this.data.collection.length > 12,
        isNewFree: authInfo.isAdminFreemium(),
      };

      return viewParams;
    },

    onRender: function () {
      this.$el.i18n();
      this.$('.js-margins').toggleClass('is-active', EditorState.get('displayMargins'));
      this._setupChangesPending(null, EditorState.getVariantChanged());

      this._setupHistoryButtons('undo', this.data.history._canUndo());
      this._setupHistoryButtons('redo', this.data.history._canRedo());
      $('.js-save').find('.ed-icon').removeClass('flip');
    },

    _setupHistoryButtons: function (action, isChanged) {
      // console.log('Setup history buttons', action, isChanged);
      this.$('.js-' + action).toggleClass('is-disabled', !isChanged);
    },

    _onHistoryTrack: function () {
      // console.log('On history track');
      this._setupHistoryButtons('undo', true);
      this._setupHistoryButtons('redo', false);
    },

    _onHistoryCommit: function (action, isChanged) {
      // console.log('On history commit', action, isChanged);
      var dualAction = action === 'undo' ? 'redo' : 'undo';
      this._setupHistoryButtons(dualAction, isChanged);
    },

    _setupChangesPending: function (model, isChanged) {
      this.$('.js-save').attr('disabled', !isChanged);
      this.$('.js-save').toggleClass('is-disabled', !isChanged);
    },
  });
});

